import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export function useRealtime() {
  useEffect(() => {
    // Realtime subscriptions are initialized here; components manage their own channels.
    return () => {};
  }, []);
}
